import { ThemeProvider } from 'next-themes';
import * as Sentry from '@sentry/react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { shouldEnableSentry } from './lib/sentry-config.ts';

const sentryEnvironment = import.meta.env.VITE_APP_ENV;

if (shouldEnableSentry(sentryEnvironment, window.location.hostname)) {
  Sentry.init({
    dsn: 'https://60b31caff8070f23c7c5816affdccc6f@o4511576844664832.ingest.us.sentry.io/4511598317993984',
    environment: sentryEnvironment,
    dataCollection: {},
    integrations: [Sentry.replayIntegration()],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}

createRoot(document.getElementById('root')!).render(
  <ThemeProvider attribute="class" defaultTheme="system" enableSystem>
    <App />
  </ThemeProvider>,
);
